module.exports = __webpack_public_path__ + "img/setup.e9dbf281.svg";